import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Finance extends React.PureComponent {
    static propTypes = {
        onOpenQrMask: PropTypes.func,
    };

    openQrMask = () => {
        const { onOpenQrMask } = this.props;

        if (onOpenQrMask) {
            onOpenQrMask();
        }
    };

    render() {
        return (
            <div className={styles.financeAd}>
                <div className={styles.financeAdText} onClick={this.openQrMask}>
                    投资、理财、买保险遇陷阱投诉无门？来百灵投诉！
                </div>
                <div className={styles.financeAdPic} onClick={this.openQrMask}>
                    <img src="https://x0.ifengimg.com/ucms/2026_23/60EFBA1DF3F1F3317636E5C418E7DB21A28A7F48_size475_w2544_h413.png" />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Finance);
